export default __webpack_public_path__ + "static/media/Frame20.6834b0e4.png";